var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"cart d-flex flex-column align-items-center",attrs:{"to":"/cart","aria-label":"cart"}},[_c('div',{ref:"quantity",staticClass:"quantity"},[_vm._v(_vm._s(_vm.cartQuantity))]),_c('CartIcon',{staticClass:"icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }